import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
// import { useMemo } from "react";
import {
  ActiveList,
  PiiBoard,
  // PostureStrip, // still on the design model - back once its API lands
  RiskTools,
} from "./-dashboard/-components";
import {
  EmptyState,
  ExposureFlow,
  LeakMap,
  ThreatBubbles,
} from "./-dashboard/charts";
// import { activeSet } from "./-dashboard/-state";
import { userInfoQueryOptions } from "@/lib/queries/auth";
import { canAccess } from "@/lib/perms";
import { useFirstAccessiblePath } from "@/components/dashboard/Sidebar";

export const Route = createFileRoute("/_app/")({
  component: RouteComponent,
  staticData: {
    // every panel here reads a statistics:view endpoint
    permissionGuards: [
      {
        resource: "statistics",
        actions: ["view"],
      },
    ],
  },
});

function RouteComponent() {
  // the panels still on the design model read the whole window
  // const active = useMemo(() => activeSet(), []);

  // "/" is where failed guards redirect to, so the root lets it through
  // even when its own guard fails; a role without the permission moves on
  // to its first sidebar page instead of a page of panels stuck on 403s.
  const userInfo = useSuspenseQuery(userInfoQueryOptions);
  const fallbackPath = useFirstAccessiblePath();
  if (!canAccess(userInfo.data, "statistics", ["view"])) {
    if (fallbackPath) return <Navigate to={fallbackPath} replace />;
    return (
      <div className="grid min-h-[60vh] w-full place-items-center p-6">
        <EmptyState
          title="You don't have access to the dashboard"
          hint="Your role is missing the statistics view permission. Ask an administrator to add it to your role."
        />
      </div>
    );
  }

  return (
    <div className="w-full p-6">
      <div className="flex flex-col gap-3.5">
        {/* <PostureStrip active={active} /> */}

        <ExposureFlow />

        <div className="flex items-baseline gap-3.5 px-0.5 pt-4">
          <h2 className="text-xl font-extrabold tracking-tight">
            Threat &amp; exposure
          </h2>
          <p className="m-0 max-w-[62ch] text-xs text-muted-foreground">
            Volume, risk and where organizational data is actually landing —
            read across the people, the apps and sites they work in, and the AI
            endpoints they reach.
          </p>
          <span className="h-px min-w-5 flex-1 bg-border" />
        </div>

        <div className="grid grid-cols-1 gap-3.5 lg:grid-cols-3">
          <ThreatBubbles />
          <LeakMap />
          <PiiBoard />
          <RiskTools />
          <ActiveList />
        </div>
      </div>
    </div>
  );
}
